import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import useSampleProjectData from '../../../../hooks/useSampleProjectData';

import { File } from '../../../../types';

import SampleAddOverlay from '../../components/sampleAddOverlay';

interface Props {
  setHlReel: React.Dispatch<React.SetStateAction<File | null>>;
  setUploadPct: React.Dispatch<React.SetStateAction<number>>;
}

const SampleComponent: React.FC<Props> = (props) => {
  const { eventId = '' } = useParams();

  const { setHlReel, setUploadPct } = props;

  const { isSample, sampleProjectData, updateSampleProjectData } =
    useSampleProjectData(eventId);
  const sampleHlReel = useMemo(
    () => sampleProjectData.hlReel || {},
    [sampleProjectData],
  );

  const imitateUploading = () => {
    setUploadPct(1);

    // imitate uploading a reel – 1% every 50ms
    const interval = setInterval(() => {
      setUploadPct((prev) => {
        if (prev >= 99) {
          const hlReel = { ...sampleHlReel };
          hlReel.isSelected = true;

          setHlReel(hlReel);
          updateSampleProjectData({
            ...sampleProjectData,
            hlReel,
            isHlReelUploaded: true,
          });

          clearInterval(interval);

          return 100;
        }

        return prev + 1;
      });
    }, 50);

    return () => clearInterval(interval);
  };

  if (!isSample) return null;

  return (
    <button
      onClick={imitateUploading}
      className="relative w-full sm:w-1/2 aspect-video rounded-md self-center overflow-hidden"
    >
      <SampleAddOverlay
        element={sampleHlReel}
        addClass="w-full h-full text-[1.75rem]"
      />

      <img
        src={sampleHlReel.thumbnailUrl}
        alt="Sample Highlight Reel"
        className="w-full h-full object-cover"
      />
    </button>
  );
};

export default SampleComponent;
